import { analysisClient } from "@/shared/lib/supabase";

export const profileMutations = {
  updateProfile: async (
    tenantUserId: string,
    updates: {
      firstname?: string | null;
      lastname?: string | null;
      position?: string | null;
    },
  ) => {
    const { data: currentSetting } = await analysisClient
      .from("tenant_user_setting")
      .select("settings")
      .eq("tenant_user_id", tenantUserId)
      .maybeSingle();

    const currentSettings =
      (currentSetting?.settings as Record<string, unknown>) || {};

    // Merge updates with current settings
    const mergedSettings = {
      ...currentSettings,
      ...(updates.firstname !== undefined && { firstname: updates.firstname }),
      ...(updates.lastname !== undefined && { lastname: updates.lastname }),
      ...(updates.position !== undefined && { position: updates.position }),
    };

    const nowIso = new Date().toISOString();

    if (currentSetting) {
      const { error: updateError } = await analysisClient
        .from("tenant_user_setting")
        .update({
          settings: mergedSettings,
          record_updated: nowIso,
        })
        .eq("tenant_user_id", tenantUserId);

      if (updateError) throw updateError;
    } else {
      const { error: insertError } = await analysisClient
        .from("tenant_user_setting")
        .insert({
          tenant_user_id: tenantUserId,
          settings: mergedSettings,
          record_created: nowIso,
          record_updated: nowIso,
        });

      if (insertError) throw insertError;
    }
  },
};
